import { RepsQuery } from "./querys"

const searchRepsWithClient = async (
  apolloClient,
  search,
  { boardId = null } = {}
) => {
  try {
    const response = await apolloClient.query({
      query: RepsQuery,
      variables: {
        boardId,
        searchTerm: search?.trim() || undefined,
      },
      fetchPolicy: "network-only",
    })

    const reps =
      response?.data?.allReps?.edges
        ?.map(edge => edge?.node)
        ?.filter(Boolean)
        ?.map(node => ({
          id: node.id,
          display: node.firstName
            ? `${node.firstName} ${node.lastName || ""}`.trim()
            : node.username,
          username: node.username,
          firstName: node.firstName,
          lastName: node.lastName,
        })) || []

    return reps
  } catch (error) {
    console.log("Error loading reps", error)
    return []
  }
}

export default searchRepsWithClient